import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import SuperAdminDashboard from './pages/super/Dashboard';
import SuperAdminShops from './pages/super/Shops';
import SuperAdminPlans from './pages/super/Plans';
import SuperAdminCategories from './pages/super/Categories';
import SuperAdminAds from './pages/super/Ads';
import SuperAdminBannerAds from './pages/super/BannerAds';
import SuperAdminCommerceAdmin from './pages/super/CommerceAdmin';
import ShopAdminDashboard from './pages/shop/Dashboard';
import ShopAdminProfile from './pages/shop/Profile';
import ShopAdminPlans from './pages/shop/Plans';
import ShopAdminAds from './pages/shop/Ads';
import ShopAdminAdDetail from './pages/shop/AdDetail';
import AgentDashboard from './pages/agent/Dashboard';
import SuperAdminAgents from './pages/super/Agents';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router future={{ v7_startTransition: true }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          {/* Super Admin Routes */}
          <Route
            path="/super/dashboard"
            element={
              <PrivateRoute allowedRoles={['superAdmin']}>
                <SuperAdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/super/commerce"
            element={
              <PrivateRoute allowedRoles={['superAdmin']}>
                <SuperAdminCommerceAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/super/shops"
            element={
              <PrivateRoute allowedRoles={['superAdmin']}>
                <SuperAdminShops />
              </PrivateRoute>
            }
          />
          <Route
            path="/super/plans"
            element={
              <PrivateRoute allowedRoles={['superAdmin']}>
                <SuperAdminPlans />
              </PrivateRoute>
            }
          />
          <Route
            path="/super/categories"
            element={
              <PrivateRoute allowedRoles={['superAdmin']}>
                <SuperAdminCategories />
              </PrivateRoute>
            }
          />
          <Route
            path="/super/ads"
            element={
              <PrivateRoute allowedRoles={['superAdmin']}>
                <SuperAdminAds />
              </PrivateRoute>
            }
          />
          <Route
            path="/super/banner-ads"
            element={
              <PrivateRoute allowedRoles={['superAdmin']}>
                <SuperAdminBannerAds />
              </PrivateRoute>
            }
          />
          <Route
            path="/super/agents"
            element={
              <PrivateRoute allowedRoles={['superAdmin']}>
                <SuperAdminAgents />
              </PrivateRoute>
            }
          />

          {/* Agent Routes */}
          <Route
            path="/agent/dashboard"
            element={
              <PrivateRoute allowedRoles={['agent']}>
                <AgentDashboard />
              </PrivateRoute>
            }
          />

          {/* Shop Admin Routes */}
          <Route
            path="/shop/dashboard"
            element={
              <PrivateRoute allowedRoles={['shopAdmin']}>
                <ShopAdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/shop/profile"
            element={
              <PrivateRoute allowedRoles={['shopAdmin']}>
                <ShopAdminProfile />
              </PrivateRoute>
            }
          />
          <Route
            path="/shop/plans"
            element={
              <PrivateRoute allowedRoles={['shopAdmin']}>
                <ShopAdminPlans />
              </PrivateRoute>
            }
          />
          <Route
            path="/shop/ads"
            element={
              <PrivateRoute allowedRoles={['shopAdmin']}>
                <ShopAdminAds />
              </PrivateRoute>
            }
          />
          <Route
            path="/shop/ads/:id"
            element={
              <PrivateRoute allowedRoles={['shopAdmin']}>
                <ShopAdminAdDetail />
              </PrivateRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

